export function Stars({ max = 5, current = 5, filled = "#FFE27A", filledDefault = "#292144", className = "" }) {
    const items = new Array(max).fill(null)
    return (
        <div className={className}>
            {items.map((i, index) => (
                <svg key={index} width="22" height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg" className="star-item">
                    <path
                        d="M10.1531 1.3489C10.5451 0.724548 11.4549 0.724548 11.8469 1.3489L14.8281 6.09713C14.9651 6.31538 15.1811 6.4723 15.431 6.53517L20.8681 7.90317C21.583 8.08305 21.8642 8.94834 21.3915 9.51409L17.7969 13.8167C17.6317 14.0144 17.5492 14.2683 17.5666 14.5254L17.9457 20.1191C17.9956 20.8546 17.2595 21.3894 16.5754 21.1147L11.3726 19.0256C11.1335 18.9296 10.8665 18.9296 10.6274 19.0256L5.42461 21.1147C4.74048 21.3894 4.00443 20.8546 4.05428 20.1191L4.43338 14.5254C4.45081 14.2683 4.36831 14.0144 4.20309 13.8167L0.608493 9.51409C0.135833 8.94834 0.416983 8.08305 1.13191 7.90317L6.56899 6.53517C6.81889 6.4723 7.03488 6.31538 7.1719 6.09713L10.1531 1.3489Z"
                        fill={index < current ? filled : filledDefault}
                    />
                </svg>
            ))}
        </div>
    )
}
